<div #formTop>
    <form *ngIf="baseFormGroup"
     [formGroup]="baseFormGroup"
     #f="ngForm"
     class="mt-4 pl-2"
    >
        <div class="row">
            <div class="col-md-12">
                <div *ngIf="varConfig.showIDs" style="background-color: yellow;">
                    <!-- #{{fc.ID.value}} -->
                </div>
                <div class="row">
                    <!-- Podvrsta dokumenta -->
                    <div class="col-lg-2">
                        <div class="form-group row">
                            <div class="col-md-12 col-12">
                                <yt-dropdown-picklist [ModelName]="'podvrstadokumentastavka'" [GetName]="'GetByUrl'"
                                    [ModelProperty]="'Sifra,Naziv'" [GetParameters]="modelData.MainList.GetParameters"
                                    formControlName="PodVrstaDokumentaStavkaID"
                                    [Label]="'EPRIJEMNICA.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
                                    [ngClass]="{'is-invalid':submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
                                    [Width]="'600px'" #autofocus [Required]="IsRequired('PodVrstaDokumentaStavkaID')"
                                    [AutoSelect]="true" [AllowAddNew]="true">
                                </yt-dropdown-picklist>
                                <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
                                    <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
                                        <span class="error-message"
                                            *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)">
                                            <span translate="{{ validation.message }}"></span>
                                        </span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Datum dokumenta -->
                    <div class="col-lg-2 col-12">
                        <div class="form-group row">
                            <div class="col-md-12">
                                <yt-fw-date-picker-popup
                                  #dtpDatumDokumenta
                                  formControlName="Datum"
                                  name="txtDatDok"
                                  [Label]="'EPRIJEMNICA.DATDOK.SINGULAR'"
                                  [ngClass]="{ 'is-invalid': submitted && fc.Datum.invalid }"
                                >
                                </yt-fw-date-picker-popup>
                                <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
                                    <span *ngFor="let validation of errorMessages.Datum">
                                        <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span
                                                translate="{{ validation.message }}"></span></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Broj dokumenta -->
                    <div class="col-lg-2 col-12">
                        <div class="form-group row">
                            <div class="col-md-8 col-8">
                                <yt-input [Type]="'text'" [Label]="'EPRIJEMNICA.BRDOK.SINGULAR'" formControlName="Broj"
                                    [ngClass]="{
                        'is-invalid': submitted && fc.Broj.invalid
                    }">
                                </yt-input>
                                <div class="form-error" *ngIf="submitted && fc.Broj.invalid">
                                    <span *ngFor="let validation of errorMessages.Broj">
                                        <span class="error-message" *ngIf="fc.Broj.hasError(validation.type)"><span
                                                translate="{{ validation.message }}"></span></span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-4 col-4">
                                <div class="input-group-append">
                                    <span class="span-control">/</span>
                                    <span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{
                                        baseFormGroup.get("Datum").value.year }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Otpremnica -->
                    <div class="col-lg-2" *ngIf="izlazna">
                        <div class="form-group row">
                            <div class="col-md-12 col-12">
                                <!-- <yt-dropdown-picklist [ModelName]="'eotpremnica'" [GetName]="'GetViewItemsByID'"
                                    [ModelProperty]="'BrojOtpremnice'" [GetParameters]="parameterList"
                                    formControlName="EOtpremnicaID" [Label]="'EPRIJEMNICA.BROJEOTPREMNICE.SINGULAR'">
                                </yt-dropdown-picklist> -->
                                <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJULAZNEOTPREMNICE.SINGULAR'"
                                  formControlName="BrojUlazneOtpremnice" [ngClass]="{
                                'is-invalid': submitted && fc.BrojOtpremnice.invalid
                                  }" [MaxLength]="50">
                                </yt-input>

                            </div>
                        </div>
                    </div>
                     <div class="col-lg-2" *ngIf="!izlazna">
                        <div class="form-group row">
                            <div class="col-md-12 col-12">
                                <!-- <yt-dropdown-picklist [ModelName]="'eotpremnica'" [GetName]="'GetViewItemsByID'"
                                    [ModelProperty]="'BrojOtpremnice'" [GetParameters]="parameterList"
                                    formControlName="EOtpremnicaID" [Label]="'EPRIJEMNICA.BROJEOTPREMNICE.SINGULAR'">
                                </yt-dropdown-picklist> -->
                                <yt-input [Type]="'text'" [Label]="'EPRIJEMNICA.BROJULAZNEPRIJEMNICE.SINGULAR'"
                                  formControlName="BrojUlaznePrijemnice" [ngClass]="{
                                'is-invalid': submitted && fc.BrojUlaznePrijemnice.invalid
                                  }" [MaxLength]="50">
                                </yt-input>

                            </div>
                        </div>
                    </div>
                    <div class="row mb-2" *ngIf="izlazna">
                      <div class="col-md-12">
                        <div class="btn-group float-right">
                          <button type="button" class="btn btn-outline-primary" (click)="SaveItem()"
                            [disabled]="saveDisabled || !buttonsConfig.SaveButtonConfig.Enable"><span
                              class="fa fa-fa fa-save"></span>
                            Sačuvaj</button>              
                          <button type="button" class="btn btn-outline-primary" (click)="onRestoreClick()"
                            [disabled]="saveDisabled"><span class="fa fa-fa fa-undo"></span> Odustani</button>
                        </div>
                      </div>
                  </div>
                </div>
            </div>
        </div>

    <div class="collapsable-container" style="margin-bottom:8px;">
      <div class="collapsable-container-header" (click)="toggleCollapseDetaljiOOtpremnici()">
        <span class="btn-collapse" (click)="toggleCollapseDetaljiOOtpremnici($event)"><span
            class="fa fa-fw fa-angle-double-down"></span></span>
        <div class="heading">{{ 'EOTPREMNICA.DETALJIOOTPREMNICI.TITLE' | translate }}</div>
      </div>
      <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsedDetaljiOOtpremnici}">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <!-- Broj otpremnice -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.BROJOTPREMNICE.SINGULAR'"
                      formControlName="BrojOtpremnice" [ngClass]="{
                'is-invalid': submitted && fc.BrojOtpremnice.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.BrojOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.BrojOtpremnice">
                        <span class="error-message" *ngIf="fc.BrojOtpremnice.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-2 col-12">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-fw-date-picker-popup
                        #dtpDatumOtpremnice
                        formControlName="DatumOtpremnice"
                        name="txtDatumOtpremnice"
                        [Label]="'EOTPREMNICA.DATUMOTPREMNICE.SINGULAR'"
                        [ngClass]="{ 'is-invalid': submitted && fc.DatumOtpremnice.invalid }"
                    >
                    </yt-fw-date-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.DatumOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.DatumOtpremnice">
                        <span class="error-message" *ngIf="fc.DatumOtpremnice.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Tip otpremnice -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.TIPOTPREMNICE.SINGULAR'"
                      formControlName="TipOtpremnice" [ngClass]="{
                'is-invalid': submitted && fc.TipOtpremnice.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.TipOtpremnice.invalid">
                      <span *ngFor="let validation of errorMessages.TipOtpremnice">
                        <span class="error-message" *ngIf="fc.TipOtpremnice.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Način otpreme -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12">
                    <yt-input [Type]="'text'" [Label]="'EOTPREMNICA.NACINOTPREME.SINGULAR'"
                      formControlName="NacinOtpreme" [ngClass]="{
                'is-invalid': submitted && fc.NacinOtpreme.invalid
                  }" [MaxLength]="50">
                    </yt-input>
                    <div class="form-error" *ngIf="submitted && fc.NacinOtpreme.invalid">
                      <span *ngFor="let validation of errorMessages.NacinOtpreme">
                        <span class="error-message" *ngIf="fc.NacinOtpreme.hasError(validation.type)"><span
                            translate="{{validation.message}}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

               <!--  (Stvarni datum i vreme otpreme - ActualDespatchPeriod) -->
              <div class="col-lg-2">
                <div class="form-group row">
                  <div class="col-md-12 col-12">
                    <yt-date-time-picker-popup #dtPickerStvarnoVremeDostave formControlName="StvarnoVremeDostave"
                      name="txtStvarnoVremeDostave"
                      [Label]="'EOTPREMNICA.STVARNOVREMEDOSTAVE.SINGULAR'"
                       [minuteStep]="1"
                        [hourStep]="1"
                    >
                    </yt-date-time-picker-popup>
                    <div class="form-error" *ngIf="submitted && fc.StvarnoVremeDostave.invalid">
                      <span *ngFor="let validation of errorMessages.StvarnoVremeDostave">
                        <span class="error-message" *ngIf="fc.StvarnoVremeDostave.hasError(validation.type)"><span
                            translate="{{ validation.message }}"></span></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>





        <!-- Prevoz -->
        <div class="row" *ngIf="angazovanPrevoznik">
            <div class="col-md-12">
                <yt-eprijemnica-prevoz-update-container
                    #baseInlineContainer1
                    [DetailModelData]="modelData.MainList.DetailList[1]"
                    [ParentPropertyName]="'EPrijemnicaID'"
                    [ParentPropertyValue]="Item?.ID" [Parameters]="TransferParameters" [Level]="'document'">
                </yt-eprijemnica-prevoz-update-container>
            </div>
        </div>
        <!-- Opasne materije -->
        <div class="row">
            <div class="col-md-12">
                <yt-eprijemnica-opasna-materija-update-container #baseInlineContainer2
                    [DetailModelData]="modelData.MainList.DetailList[2]" [ParentPropertyName]="'EPrijemnicaID'"
                    [ParentPropertyValue]="Item?.ID" [Parameters]="TransferParameters" [Level]="'document'">
                </yt-eprijemnica-opasna-materija-update-container>
            </div>
        </div>
        <!-- Stavke otpremnice -->
        <div class="row">
            <div class="col-md-12">
                <yt-eprijemnica-stavka-update-container *ngIf="modelData?.MainList?.DetailList?.length > 0 && Item?.ID"
                    #baseInlineContainer [DetailModelData]="modelData.MainList.DetailList[0]"
                    [ParentPropertyName]="'EPrijemnicaID'" [ParentPropertyValue]="Item?.ID"
                    [Parameters]="TransferParameters" [Level]="'document'">
                </yt-eprijemnica-stavka-update-container>
            </div>
        </div>
    </form>
</div>
